
const data = [
    {
        name : 'BBC Business News',
        icon : '/images/publisher-icons/bbc.svg',
        domain : 'https://www.bbc.co.uk/news/business'
    },
    {
        name : 'New York Times',
        icon : '/images/publisher-icons/new-york-times.svg',
        domain : 'https://www.nytimes.com/section/business'
    },
    {
        name : 'Sky News Business',
        icon : '/images/publisher-icons/sky-news.svg',
        domain : 'https://news.sky.com/business'
    },
    {
        name : 'Wall Street Journal',
        icon : '/images/publisher-icons/the-wall-street-journal.svg',
        domain : 'https://www.wsj.com/europe'
    }
];

export default function publishers( name ){
    return data.find( publisher => publisher.name.toLowerCase() === name.toLowerCase() );
};



// WEBPACK FOOTER //
// src/client/components/site/features/homepage/helpers/publishers.js